import { MobileSdkTypes } from 'src/common/helpers/MobileQueriesHelper';

export const MOBILE_SDK_DOCUMENTATION_LINK = {
	APPIUM_JAVA: 'https://developer.evinced.com/sdks-for-mobile-apps/appium-sdk-java-doc',
	APPIUM_PYTHON: 'https://developer.evinced.com/sdks-for-mobile-apps/appium-sdk-python-doc',
	ESPRESSO: 'https://developer.evinced.com/sdks-for-mobile-apps/espresso-sdk',
	WDIO_MOBILE: 'https://developer.evinced.com/sdks-for-mobile-apps/wdio-mobile-sdk',
	XCUI: 'https://developer.evinced.com/sdks-for-mobile-apps/xcui-sdk'
} as const;

export type MobileSdkDocumentationLink =
	(typeof MOBILE_SDK_DOCUMENTATION_LINK)[keyof typeof MOBILE_SDK_DOCUMENTATION_LINK];

export type MobileSdkInfo = {
	label: MobileSdkTypes;
	version: string;
};
